import { appConfig } from 'config/customization';
import { iconTitle } from 'constants/fonts';

const row = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  boxSizing: 'border-box',
  width: '100%',
  padding: '5px 6px'
};

export default {
  oddRow: {
    ...row,
    background: appConfig.colors.oddRowColor
  },
  evenRow: {
    ...row,
    background: appConfig.colors.evenRowColor
  },
  container: {
    marginTop: 10
  },
  billIcon: {
    backgroundColor: appConfig.colors.billIconColor,
    borderRadius: '50%',
    color: appConfig.colors.white,
    fontSize: iconTitle,
    marginRight: 10,
    padding: '7px 0',
    width: 32
  }
};
